import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import categoryService from "../Services/Service";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Paper,
  Modal,
  Box,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CategoryManager = () => {
  const categoryRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ id: "0", name: "" });
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    categoryService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/Category",
    );
    //categoryService.setApiUrl("https://localhost:7106/api/Category");
    fetchCategories();
  }, []);

  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchCategories = async () => {
    const res = await categoryService.getAll();
    setCategories(res.data);
  };

  const clear = () => {
    setForm({ id: "0", name: "" });
    if (categoryRef.current) categoryRef.current.value = "";
    setEditing(false);
  };

  const handleBlur = (e) => {
    const value = e.target.value.trim();
    if (!value) return;

    const found = categories.some(
      (cat) => cat.categoryName.toLowerCase() === value.toLowerCase(),
    );
    if (found) {
      //alert("Duplicate Category!");
      setSnackbar({
        open: true,
        message: "Duplicate Category!",
        severity: "error",
      });
      e.target.value = "";
      e.target.focus();
    } else {
      setForm((prev) => ({ ...prev, name: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = categoryRef.current?.value.trim();

  // 1. Empty / whitespace-only validation
  if (!value) {
    setSnackbar({
      open: true,
      message: "Category name is required!",
      severity: "error",
    });
    return;
  }

  // 2. Only alphabets, spaces and hyphens allowed
  const categoryNameRegex = /^[A-Za-z]+(?:[ -][A-Za-z]+)*$/;

  if (!categoryNameRegex.test(value)) {
    setSnackbar({
      open: true,
      message:
        "Category name can contain only alphabets, spaces and hyphens!",
      severity: "error",
    });
    return;
  }

  // 3.Check duplicate category
  const found = categories.some(
    (cat) =>
      cat.categoryName.toLowerCase() === value.toLowerCase() &&
      (!editing || cat.categoryId !== form.id)
  );

  if (found) {
    setSnackbar({
      open: true,
      message: "Duplicate Category!",
      severity: "error",
    });

    categoryRef.current.value = "";
    categoryRef.current.focus();

    return; // IMPORTANT: don't call API
  }

    try {
      const response = await categoryService.create({
        CategoryId: form.id,
        CategoryName:value, // always take latest from ref
        OpFlag: editing ? "Update" : "Insert",
      });
      let vOutput = response.data.message.split(":");
      clear();
      fetchCategories();
      setOpen(false);
      setSnackbar({
        open: true,
        //message: editing ? "Category updated successfully!" : "Category added successfully!",
        message: vOutput[0],
        severity: vOutput[1],
      });
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const handleEdit = (category) => {
    //debugger;
    setForm({ id: category.categoryId, name: category.categoryName });
    if (categoryRef.current) {
      categoryRef.current.value = category.categoryName;
    }
    setEditing(true);
    setOpen(true);
  };

  // const handleDelete = async (id) => {
  //   debugger;
  //   if (window.confirm("Are you sure to delete this category?")) {
  //     await categoryService.remove(id, "Delete");
  //     fetchCategories();
  //   }
  // };
  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };
  const confirmDelete = async () => {
    try {
      const response = await categoryService.remove(deleteId, "Delete");
      let vOutput = response.data.message.split(":");
      fetchCategories();
      setSnackbar({
        open: true,
        message: vOutput[1],
        severity: vOutput[0],
      });
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Error deleting category!",
        severity: "error",
      });
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const handleAddClick = () => {
    clear();
    setOpen(true);
  };

  // Columns for MUI DataGrid
  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    { field: "categoryId", headerName: "ID" },
    {
      field: "categoryName",
      headerName: "Category Name",
      flex: 1,
      sortable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            height: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => handleDelete(params.row.categoryId)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="category-grid-wrapper">
      <Box
        sx={{
          mt: 4,
          bgcolor: "background.paper", // white/light background
          borderRadius: 3, // rounded corners
          boxShadow: 6, // floating shadow
          p: 4, // inner padding
          border: "1px solid rgba(0,0,0,0.12)", // subtle border
          width: "100%",
          overflow: "auto",
        }}
      >
        {/* <Button variant="contained" onClick={handleAddClick} sx={{ mb: 2 }}>
          Add Category
        </Button> */}

        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/DashboardFinal")}
          >
            Back to Home
          </Button>
          <Button variant="contained" onClick={handleAddClick}>
            Add Category
          </Button>
        </Box>

        {/* DataGrid wrapper */}
        <div className="datagrid-container">
          <DataGrid
            rows={categories}
            columns={columns}
            columnVisibilityModel={{
              categoryId: false,
            }}
            getRowId={(row) => row.categoryId}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
            components={{ Toolbar: GridToolbar }}
            sx={{
              "& .MuiDataGrid-root": {
                fontSize: "0.875rem",
              },
              "& .MuiDataGrid-cell": {
                padding: "8px 12px",
              },

              "& .MuiDataGrid-columnHeader": {
                padding: "8px 4px",
              },
              "@media (max-width: 768px)": {
                "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
                  padding: "6px 2px",
                  fontSize: "0.75rem",
                },
              },
              "@media (max-width: 480px)": {
                "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
                  padding: "4px 2px",
                  fontSize: "0.7rem",
                },
              },
            }}
          />
        </div>

        {/* Modal */}
        <Modal open={open} onClose={() => setOpen(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              width: 400,
            }}
          >
            <h4>{editing ? "Edit" : "Add"} Category</h4>
            <form onSubmit={handleSubmit}>
              <TextField
                inputRef={categoryRef}
                label="Category Name"
                fullWidth
                required
                defaultValue={form.name}
                sx={{ mb: 2 }}
                onBlur={handleBlur}
              />
              <Box display="flex" justifyContent="flex-end">
                <Button onClick={() => setOpen(false)} sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained">
                  {editing ? "Update" : "Add"}
                </Button>
              </Box>
            </form>
          </Box>
        </Modal>

        {/* Snackbar */}
        {/* <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        > */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={(event, reason) => {
            if (reason === "clickaway") {
              return;
            }

            handleSnackbarClose();
          }}
          //anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>

        {/* Confirm Dialog */}
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <DialogTitle>{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this category?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              color="error"
              variant="contained"
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};
export default CategoryManager;
